const column = "_61c1hhpyul";
const columnCenter = "_61co2l3yr";
const title = "_61tfwlqvr";
const link = "_61l146eofi";

export { column, columnCenter, link, title };
import "./column.style.linaria.module.css";
//# sourceMappingURL=column.style.js.map
